import { cva, type VariantProps } from 'class-variance-authority';
import { type HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

const badgeVariants = cva(
  'inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-2 py-0.5 text-[11.5px] font-medium leading-4 [&_svg]:size-3 [&_svg]:shrink-0',
  {
    variants: {
      tone: {
        neutral: 'border-border bg-surface-2 text-fg-muted',
        primary: 'border-transparent bg-primary-soft text-primary-text',
        accent: 'border-transparent bg-accent-soft text-primary-text',
        success: 'border-transparent bg-success-soft text-success',
        warning: 'border-transparent bg-warning-soft text-warning',
        danger: 'border-transparent bg-danger-soft text-danger',
        info: 'border-transparent bg-info-soft text-info',
        outline: 'border-border bg-transparent text-fg-muted',
      },
    },
    defaultVariants: { tone: 'neutral' },
  },
);

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {}

export function Badge({ className, tone, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ tone }), className)} {...props} />;
}

/** Subtle pill used for "Soon" / planned modules. */
export function SoonBadge({ className, label = 'Soon' }: { className?: string; label?: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full bg-accent-soft px-1.5 py-px text-[10px] font-semibold tracking-wide text-primary-text uppercase',
        className,
      )}
    >
      {label}
    </span>
  );
}
